import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { AvailableDateService } from '../available-date.service';
import { PublicService } from '../public.service';

export const useGetAvailableDate = (
	professional_id: string,
	options?: Omit<
		UseQueryOptions<AvailableDates.SessionAvailableDatesResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['available-dates', professional_id],
		queryFn: () => AvailableDateService.get(professional_id),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetPublicAvailableDate = (
	professional_id: string,
	options?: Omit<
		UseQueryOptions<AvailableDates.SessionAvailableDatesResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['public-available-dates', professional_id],
		queryFn: () => PublicService.getAvailableDatePublic(professional_id),
		refetchOnWindowFocus: false,
		...options,
	});
};
